import { call, put, takeEvery, takeLatest } from "redux-saga/effects";
import { apiWrapper } from "../../../api/apiWrapper";
import { IBaseResponeModel } from "../../../models/response/base-response";
import { sf_hinhthucmiengiam } from "../../../models/response/hinh-thuc-mien-giam/sf_hinhthucmiengiam";
import { eHinhThucMienGiamActionTypeIds } from "../../action-types/hinh-thuc-mien-giam/IHinhThucMienGiamActionTypes";
import { actions } from "../../actions/actionsWrapper";
import { IHinhThucMienGiamActionTypes } from "../../action-types/hinh-thuc-mien-giam/IHinhThucMienGiamActionTypes";

const actionWrapper = actions.hinhThucMienGiam;

export function* hinhThucMienGiamSaga(): any {
  yield takeLatest(eHinhThucMienGiamActionTypeIds.LOAD_START, loadWorker);
  yield takeEvery(eHinhThucMienGiamActionTypeIds.SAVE_START, saveWorker);
  yield takeEvery(eHinhThucMienGiamActionTypeIds.DELETE_START, deleteWorker);
}

function* loadWorker(action: IHinhThucMienGiamActionTypes): any {
  const payload = action.payload as { nam_hoc: string; dm_coso_id: number };
  const res: IBaseResponeModel = yield call(
    apiWrapper.hinhThucMienGiam.selectByCoso,
    payload.dm_coso_id
  );
  if (res.is_success) {
    yield put(actionWrapper.LOAD_SUCCESS(res.data));
  } else {
    yield put(actionWrapper.LOAD_ERROR(res.message ?? "Error"));
  }
}

function* saveWorker(action: IHinhThucMienGiamActionTypes): any {
  const payload = action.payload as sf_hinhthucmiengiam;
  let res: IBaseResponeModel;
  if (payload.id && payload.id > 0) {
    res = yield call(apiWrapper.hinhThucMienGiam.update, payload);
  } else {
    res = yield call(apiWrapper.hinhThucMienGiam.insert, payload);
  }
  if (res.is_success) {
    yield put(actionWrapper.SAVE_SUCCESS(res.data));
  } else {
    yield put(actionWrapper.SAVE_ERROR(res.message ?? "Error"));
  }
}

function* deleteWorker(action: IHinhThucMienGiamActionTypes): any {
  const payload = action.payload as number[];
  const res: IBaseResponeModel = yield call(
    apiWrapper.hinhThucMienGiam.delete,
    payload
  );
  if (res.is_success) {
    yield put(actionWrapper.DELETE_SUCCESS(undefined));
  } else {
    yield put(actionWrapper.DELETE_ERROR(res.message ?? "Error"));
  }
}


